import {Component, OnInit} from '@angular/core';
import {Localiser} from "../../../services/localiser";
import {UserService} from "../../../services/user.service";
import {IndicatorsService} from "../../../services/indicators.service";
import {Navigation} from "../../../services/navigation.service";
import {LuminariaService} from "../../../services/luminaria.service";
import {ProyectoService} from "../../../services/proyecto.service";
import {PlanoService} from "../../../services/plano.service";
import {ZonaService} from "../../../services/zona.service";
import {AlertaService} from "../../../services/alerta.service";
import {Chart, registerables} from "chart.js";
import {alert} from "../../../models/alert";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {SensorService} from "../../../services/sensor.service";
import {sensor} from "../../../models/sensor";

@Component({
  selector: 'app-indicators-presences',
  templateUrl: './indicators-presences.component.html',
  styleUrls: ['./indicators-presences.component.css']
})
export class IndicatorsPresencesComponent implements OnInit {

  sensores = [];
  sensoresFiltro = [];
  sensoresReal = [];
  presencias = [];

  planos: Array<plano>;
  zonas: Array<zona>;
  showZonas = [];
  planoSelected: plano | any = -1;
  zonaSelected: zona | any = -1;
  searcherLuminarias: string = "";
  startCustomTime: undefined;
  endCustomTime: undefined;

  loading: boolean = false;
  selectedSensors: Array<sensor> = [];
  presenciasFilterTime = 1;
  presenciasChart: Chart;

  constructor(public localiser: Localiser, public user: UserService, private navigation: Navigation,
              public proyectoService: ProyectoService, private planoService: PlanoService,
              private zonaService: ZonaService, private alertaService: AlertaService,
              private sensorService: SensorService) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    // Prepara el canvas para la gráfica
    this.presencesChart();
    // Hace GET de los sensores de presencia del proyecto
    this.getSensores();
    // Hace GET de los planos del proyecto
    this.getPlanos();
    // Hace GET de las zonas del proyecto
    this.getZonas();
  }

  /*
    GET Sensores de presencia del proyecto
    Se guardan en:
      - sensoresReal: Todos los sensores
      - sensoresFiltro: Los sensores una vez se han aplicado filtros
      - sensores: Los sensores que se muestran en el HTML

      Por defecto al entrar a la pantalla se muestran todos y se selecciona el primero.
   */
  getSensores() {
    this.sensorService.getSensoresPresenciaByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((response: Array<sensor>) => {
      this.sensoresReal = response;
      this.sensoresFiltro = this.sensoresReal;
      this.sensores = this.sensoresFiltro;
      if (this.sensores.length > 0) {
        this.selectedSensors.push(this.sensores[0]);
        // Se piden las presencias al servidor
        this.getPresencias();
      }
    });
  }

  /*
    GET presencias de los sensores filtrados (sensoresFiltro) según que timestamp esté elegido
    Las presencias según el instante de tiempo se almacenan en *this.presencias* como:
      - {idDispositivo: <MAC(string)>, presencias: <Array<timestamp_presencia(int)>}
   */
  getPresencias() {
    this.loading = true;
    let timestamps = this.getTimestamps();
    for (let sensor of this.sensoresFiltro) {

      // Si hay algún sensor con sus presencias ya cargadas no se vuelve a pedir
      if (!this.isSensorLoaded(sensor.idLuminaria)) {
        this.alertaService.getPresenciasByTimestamps(sensor.idLuminaria, timestamps.init, timestamps.end).subscribe((result) => {
          this.presencias.push({idDispositivo: sensor.idLuminaria, presencias: result});
          // Actualizar canvas
          this.changePresenciasChart();
        })
      }
    }
  }

  /*
    Devuelve true si el sensor ya tiene cargadas sus presencias
   */
  isSensorLoaded(idDispositivo) {
    return this.presencias.find(o => {return o.idDispositivo === idDispositivo}) != undefined;
  }

  /*
    Devuelve cuantas presencias tiene un sensor cargadas
   */
  countPresencias(idDispositivo) {
    return this.presencias.find(o => {return o.idDispositivo === idDispositivo}).presencias.length;
  }

  /*
    Devuelve el timestamp de inicio (init) y final (end) para la petición de las presencias en el servidor
      según el instante de tiempo seleccionado como:
      - {init: <timestamp(int)>, end: init: <timestamp(int)>}
   */
  getTimestamps() {
    if (this.presenciasFilterTime == 1) {
      return this.getTimestampsToday();
    } else if (this.presenciasFilterTime == 2) {
      return this.getTimestampsYesterday();
    } else if (this.presenciasFilterTime == 3) {
      return this.getTimestampsWeek();
    } else if (this.presenciasFilterTime == 4) {
      return this.getTimestampsMonth();
    } else if (this.presenciasFilterTime == 5) {
      return this.getTimestampsYear();
    } else if (this.presenciasFilterTime == 6) {
      return this.getTimestampsCustom();
    } else {
      return undefined;
    }
  }

  getTimestampsToday() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return {"init": today.getTime(), "end": new Date().getTime()};
  }

  getTimestampsYesterday() {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return {"init": yesterday.getTime(), "end": today.getTime()};
  }

  getTimestampsWeek() {
    let week = new Date();
    week.setDate(week.getDate() - 6);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsMonth() {
    let week = new Date();
    week.setDate(week.getDate() - 30);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsYear() {
    let week = new Date();
    week.setDate(week.getDate() - 365);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsCustom() {
    return {"init": new Date(this.startCustomTime).getTime(), "end": new Date(this.endCustomTime).getTime()};
  }

  /*
    GET Planos del proyecto
   */
  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
  }

  /*
    GET Zonas del proyecto
   */
  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonas = result;
    })
  }

  /*
    Selecciona un plano y adapta los sensores y otros filtros que se muestran
   */
  selectPlano(planoEv) {
    if (planoEv == -1) {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.sensoresFiltro = this.sensoresReal;
      this.sensores = this.sensoresFiltro;
      this.showZonas = this.zonas;

      // Comprueba si hay algo escrito en el filtro de buscar por Nombre o ID
      this.searcherLuminariasFunc();
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == planoEv.idPlano);
      this.zonaSelected = undefined;
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == this.planoSelected.idPlano;
      });
      this.sensoresFiltro = this.sensoresReal.filter(sensor => sensor.idPlano == planoEv.idPlano);
      this.sensores = this.sensoresFiltro;

      // Comprueba si hay algo escrito en el filtro de buscar por Nombre o ID
      this.searcherLuminariasFunc();
    }
  }

  /*
    Selecciona una zona y adapta los sensores y otros filtros que se muestran
   */
  selectZona(zonaEv) {
    if (zonaEv == -1) {
      this.zonaSelected = undefined;
      this.selectPlano(this.planoSelected)
    } else {
      this.zonaSelected = this.showZonas.find(zona => zona.id == zonaEv.id);
      this.sensoresFiltro = this.sensoresReal.filter(sensor => sensor.idZona == zonaEv.id);
      this.sensores = this.sensoresFiltro;

      // Comprueba si hay algo escrito en el filtro de buscar por Nombre o ID
      this.searcherLuminariasFunc();
    }
  }

  /*
    Filtra los sensores por Nombre o ID a través de un input
   */
  searcherLuminariasFunc() {
    this.sensores = this.sensoresFiltro.filter(sensor =>
      (sensor.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (sensor.idLuminaria.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
    this.selectedSensors = [];
    this.sensores.forEach(sens => this.selectedSensors.push(sens));

    // GET de las presencias en caso de que haya sensores que no las tengan
    this.getPresencias();

    // Actualizar canvas
    this.changePresenciasChart();
  }

  /*
    Cambia el instante temporal de las presencias
    Resetea las presencias y pide nuevas al servidor con el nuevo instante temporal
   */
  changePresenciasFilterTime(n: number) {
    this.presenciasFilterTime = n;
    this.presencias = [];

    // Actualizar canvas
    this.changePresenciasChart();

    // Si el timestamp no ha cambiado a custom o si y no son indefinidos
    if (n != 6 || (this.startCustomTime != undefined && this.endCustomTime != undefined)) {
      // GET de las presencias
      this.getPresencias();
    } else {
      for (let sensor of this.sensoresReal) {
        this.presencias.push({idDispositivo: sensor.idLuminaria, presencias: []});
      }
    }
  }

  /*
    Comprueba si los inputs de los timestamps customs
   */
  checkDisabledCustom() {
    return this.startCustomTime == undefined || this.endCustomTime == undefined ||
      (new Date(this.startCustomTime).getTime() >= new Date(this.endCustomTime).getTime()) ||
      (new Date(this.endCustomTime).getTime() - new Date(this.startCustomTime).getTime()) > 86400000 * 366 * 2;
  }

  /*
    Selecciona o deselecciona un sensor
   */
  changeSelectSensor(sensor: sensor) {
    if (this.checkSelectedSensor(sensor)) {
      this.selectedSensors.splice(this.selectedSensors.findIndex(sens => sens.idDispositivo == sensor.idDispositivo), 1);
    } else {
      this.selectedSensors.push(sensor);
    }

    // Actualizar canvas
    this.changePresenciasChart();
  }

  /*
    Deseleccionar o seleccionar todos los sensores
   */
  unselectAllSensors() {
    if (this.selectedSensors.length != 0) {
      this.selectedSensors = [];
    } else {
      this.selectedSensors.push(...this.sensores);
    }
    // Actualizar canvas
    this.changePresenciasChart();
  }

  /*
    Comprueba si un sensor está seleccionado
   */
  checkSelectedSensor(sensor) {
    return this.selectedSensors.find(sens => sens.idDispositivo == sensor.idDispositivo) != undefined;
  }

  /*
    Recarga el canvas según el instante temporal y las luminarias seleccionadas
   */
  changePresenciasChart() {

    // Carga el dataset para el canvas según el instante temporal
    let dataset;
    if (this.presenciasFilterTime == 1) {
      dataset = this.setPresenciasToday();
    } else if (this.presenciasFilterTime == 2) {
      dataset = this.setPresenciasYesterday();
    } else if (this.presenciasFilterTime == 3) {
      dataset = this.setPresenciasWeek();
    } else if (this.presenciasFilterTime == 4) {
      dataset = this.setPresenciasMonth();
    } else if (this.presenciasFilterTime == 5) {
      dataset = this.setPresenciasYear();
    } else if (this.presenciasFilterTime == 6) {
      dataset = this.setPresenciasCustom();
    } else {
      dataset = {labels: [], data: []};
    }

    // Actualiza el canvas según el dataset
    if (dataset != undefined) {
      this.presenciasChart.data = {
        labels: dataset.labels,
        datasets: [{
          label: 'Presences',
          data: dataset.data,
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }]
      }
      this.presenciasChart.update();
    }
  }

  /*
    Filtra las presencias según las horas del día actual
   */
  setPresenciasToday() {
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    let hours = (new Date().getTime() - today.getTime()) / 3600000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(i + ':00')
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= today.getTime()) &&
        ((pres * 1000) < (today.getTime() + 3600000))).length);
      today.setTime(today.getTime() + 3600000);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra las presencias según las horas del día anterior
   */
  setPresenciasYesterday() {
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    let yesterday: Date = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0);
    yesterday.setMinutes(0);
    yesterday.setSeconds(0);
    let hours = (today.getTime() - yesterday.getTime()) / 3600000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(i + ':00')
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= yesterday.getTime()) &&
        ((pres * 1000) < (yesterday.getTime() + 3600000))).length);
      yesterday.setTime(yesterday.getTime() + 3600000);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra las presencias según los últimos 7 días
   */
  setPresenciasWeek() {
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setTime(today.getTime() - (86400000 * 6));
    let hours = (new Date().getTime() - today.getTime()) / 86400000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= today.getTime()) &&
        ((pres * 1000) < (today.getTime() + 86400000))).length);
      today.setTime(today.getTime() + 86400000);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra las presencias según los últimos 30 días
   */
  setPresenciasMonth() {
    let today: Date = new Date();
    today.setTime(today.getTime() - (86400000 * 30));
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    let hours = (new Date().getTime() - today.getTime()) / 86400000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= today.getTime()) &&
        ((pres * 1000) < (today.getTime() + 86400000))).length);
      today.setTime(today.getTime() + 86400000);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra las presencias según los meses del año actual
   */
  setPresenciasYear() {
    let today: Date = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setDate(1);
    today.setFullYear(today.getFullYear() - 1);
    today.setMonth(today.getMonth() + 1)
    let months = 12;
    let labels = [];
    let data = [];
    let nextMonth: Date = new Date(today.getTime());
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    for (let i = 0; i < months; i++) {
      labels.push((today.getMonth() + 1) + "/" + today.getFullYear())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= today.getTime()) &&
        ((pres * 1000) < nextMonth.getTime())).length);
      today.setMonth(today.getMonth() + 1)
      nextMonth.setMonth(nextMonth.getMonth() + 1);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra las presencias según el custom input
   */
  setPresenciasCustom() {
    // Up to 6 hours: minute granularity (max ~360 data points)
    if (new Date(this.startCustomTime).getTime() + (60000 * 360) >= new Date(this.endCustomTime).getTime()) {
      return this.setPresenciasCustomByMinutes();
    } else if (new Date(this.startCustomTime).getTime() + (3600000 * 40) >= new Date(this.endCustomTime).getTime()) {
      return this.setPresenciasCustomByHours();
    } else if (new Date(this.startCustomTime).getTime() + (86400000 * 40) >= new Date(this.endCustomTime).getTime()) {
      return this.setPresenciasCustomByDays();
    } else {
      return this.setPresenciasCustomByMonths();
    }
  }

  setPresenciasCustomByMinutes() {
    let start: Date = new Date(this.startCustomTime);
    let end: Date = new Date(this.endCustomTime);
    start.setSeconds(0);
    let minutes = (end.getTime() - start.getTime()) / 60000;
    let labels = [];
    let data = [];
    for (let i = 0; i < minutes; i++) {
      labels.push(start.getHours() + ':' + (start.getMinutes() < 10 ? '0' : '') + start.getMinutes())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= start.getTime()) &&
        ((pres * 1000) < (start.getTime() + 60000))).length);
      start.setTime(start.getTime() + 60000);
    }
    return {labels: labels, data: data}
  }

  setPresenciasCustomByHours() {
    let start: Date = new Date(this.startCustomTime);
    let end: Date = new Date(this.endCustomTime);
    start.setMinutes(0);
    start.setSeconds(0);
    let hours = (end.getTime() - start.getTime()) / 3600000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(start.getHours() + ':00')
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= start.getTime()) &&
        ((pres * 1000) < (start.getTime() + 3600000))).length);
      start.setTime(start.getTime() + 3600000);
    }
    return {labels: labels, data: data}
  }

  setPresenciasCustomByDays() {
    let start: Date = new Date(this.startCustomTime);
    let end: Date = new Date(this.endCustomTime);
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    let hours = (end.getTime() - start.getTime()) / 86400000;
    let labels = [];
    let data = [];
    for (let i = 0; i < hours; i++) {
      labels.push(start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= start.getTime()) &&
        ((pres * 1000) < (start.getTime() + 86400000))).length);
      start.setTime(start.getTime() + 86400000);
    }
    return {labels: labels, data: data}
  }

  setPresenciasCustomByMonths() {
    let start: Date = new Date(this.startCustomTime);
    let end: Date = new Date(this.endCustomTime);
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setDate(1);
    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth() + (12 * years);
    let labels = [];
    let data = [];
    let nextMonth: Date = new Date(start.getTime());
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    for (let i = 0; i < months + 1; i++) {
      labels.push((start.getMonth() + 1) + "/" + start.getFullYear())
      data.push(this.filterPresenciasBySelectedSensor().filter(pres =>
        ((pres * 1000) >= start.getTime()) &&
        ((pres * 1000) < nextMonth.getTime())).length);
      start.setMonth(start.getMonth() + 1)
      nextMonth.setMonth(nextMonth.getMonth() + 1);
    }
    return {labels: labels, data: data}
  }

  /*
    Filtra y mapea las presencias según los sensores seleccionados
   */
  filterPresenciasBySelectedSensor() {
    let presenciasFiltered = this.presencias.filter(pres => this.selectedSensors.some(sens => sens.idLuminaria == pres.idDispositivo));
    return [].concat(...presenciasFiltered.map(o => o.presencias));
  }

  /*
    Carga el canvas para la gráfica
   */
  presencesChart() {
    this.presenciasChart = new Chart('presenciasChart', {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          label: 'Presences',
          data: [],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined'
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }

  toIndicators() {
    this.navigation.toIndicators();
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
